import { cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export const defaultLicenseKeyItem = () => ({
  id: uuidv4(),
  keySegments: ["", "", "", ""],
  credits: "-",
})

export const defaultImportCreditsObj = () => ({
  licenseKeys: [
    defaultLicenseKeyItem()
  ],
})
